import React, {useEffect, useState, useMemo} from "react";
import { Link, useLocation } from "react-router-dom";
import { sliderContent } from "../../services/StaticService";
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Hero = () => {

  const location = useLocation();
  const [sliderdata, setSliderData] = useState([]);

  const getSliderContent = async () => {
    const result = await sliderContent();
    if (result?.length > 0) {
      setSliderData(result);
    }
  }

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const showSliderContent = useMemo(() => {
    return sliderdata?.length > 0 && sliderdata?.map((slider, index) => {
      return (
        <div className="text-center" key={index}>
          <h6 dangerouslySetInnerHTML={{__html: slider.title}}></h6>
          <p dangerouslySetInnerHTML={{__html: slider.description}}></p>
        </div>
      )
    });
  }, [sliderdata]);

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
    getSliderContent();
  }, [location]);

  return (
    <section className="hero-section ">
      <header className="page-header">
        <div className="container">
          <nav className="navbar navbar-expand-md">
            <Link className="navbar-brand" to="/">
              <img
                src="assets/imges/AI-Logo.png"
                alt="AI"
                width={100}
                height={100}
                className="img-fluid"
              />
            </Link>
            <div className="mobile_nav d-md-none">
              <li className="nav-item">
                <Link className="Download_btn black" to="#">
                  <img src="assets/imges/camera.svg" alt="camera" />
                </Link>
              </li>
              <li className="nav-item">
                <Link className="Download_btn black" to="#download_sec">
                  Download
                </Link>
              </li>
              <button
                className="btn toogle_btn d-md-none"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasExample"
                aria-controls="offcanvasExample"
              >
                <span>
                  <img src="assets/imges/menu.svg" alt="menuicon" />
                </span>
              </button>
            </div>
            <div
              className="offcanvas offcanvas-start"
              tabIndex={-1}
              id="offcanvasExample"
              aria-labelledby="offcanvasExampleLabel"
            >
              <div className="offcanvas-header">
                <h5
                  className="offcanvas-title yellow"
                  id="offcanvasExampleLabel"
                >
                  <Link to="/" className="AI_logo">
                    <img src="assets/imges/AI-Logo.png" alt="AI" width={62} />
                  </Link>
                  Ai-Cook
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                />
              </div>
              <div className="offcanvas-body">
                <nav className="navbar menubar">
                  <ul className="navbar-nav">
                    <li className="nav-item">
                      <Link className="nav-link" to="#home">
                        Home
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="#about-us">
                        About
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="#FAQ_sec">
                        FAQ
                      </Link>
                    </li>
                    <li className="nav-item d-none d-md-block">
                      <Link className="Download_btn black" to="#">
                        <img src="assets/imges/camera.svg" alt="camera" />
                      </Link>
                    </li>
                    <li className="nav-item d-none d-md-block">
                      <Link className="Download_btn black" to="#download_sec">
                        Download
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </nav>
        </div>
      </header>
      <div className="container" id="home">
        <div className="row align-items-center">
          <div className="col-lg-5 col-md-12 order-lg-1 order-2 slider_content">
            <div>
              <Slider {...settings}>
                {showSliderContent}
              </Slider>
            </div>
          </div>
          <div className="col-lg-7 col-md-12 text-lg-end  order-lg-2 order-1 mb-5 mb-lg-0">
            <img src="./assets/imges/AI.png" alt="ai" className="img-fluid" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
